
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

// お知らせモーダル
export function NoticeModal({ open, message, onClose }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>お知らせ</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export const ConfirmModal = ({ open, message, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>確認</DialogTitle>
    <DialogContent>{message}</DialogContent>
    <DialogActions>
      <Button onClick={onCancel} variant="outlined">
        いいえ
      </Button>
      <Button onClick={onConfirm} variant="contained" color="primary">
        はい
      </Button>
    </DialogActions>
  </Dialog>
);